export default __webpack_public_path__ + "static/media/Inter-UI-ThinItalic-BETA.295ed5a1.woff";